import { useSyncExternalStore } from "react";
import type { IVScoreResponse } from "../types/market-data";

export interface IvScoreSnapshot {
  data: IVScoreResponse | null;
  error: string | null;
  loading: boolean;
}

const EMPTY_SNAPSHOT: IvScoreSnapshot = {
  data: null,
  error: null,
  loading: true,
};

const snapshots = new Map<string, IvScoreSnapshot>();
const listeners = new Set<() => void>();

export function publishIvScore(
  instrument: string,
  update: Partial<IvScoreSnapshot>,
) {
  const key = normalizeInstrument(instrument);
  snapshots.set(key, { ...readIvScore(key), ...update });
  listeners.forEach((listener) => listener());
}

export function useIvScoreSnapshot(instrument: string): IvScoreSnapshot {
  const key = normalizeInstrument(instrument);
  return useSyncExternalStore(
    subscribe,
    () => readIvScore(key),
    () => EMPTY_SNAPSHOT,
  );
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function readIvScore(instrument: string) {
  return snapshots.get(instrument) ?? EMPTY_SNAPSHOT;
}

function normalizeInstrument(instrument: string) {
  return instrument.replace(/^\//, "").trim().toUpperCase();
}
